import { useEffect, useState } from 'react';
import jsBridge from '@utils/jsBridge';

export const DEVICE_MOBILE = 'mobile';
export const DEVICE_DESKTOP = 'desktop';
export type DeviceType = typeof DEVICE_MOBILE | typeof DEVICE_DESKTOP;

const useDeviceType = (): DeviceType => {
  const [deviceType, setDeviceType] = useState<DeviceType>('desktop');

  useEffect(() => {
    // Media query for mobile devices (up to 768px)
    const mobileQuery = window.matchMedia('(max-width: 768px)');
    // Desktop is anything above 768px

    const updateDeviceType = () => {
      setDeviceType(mobileQuery.matches ? 'mobile' : 'desktop');
    };

    // Initial check
    updateDeviceType();

    // Add event listener
    mobileQuery.addEventListener('change', updateDeviceType);

    // Cleanup
    return () => {
      mobileQuery.removeEventListener('change', updateDeviceType);
    };
  }, []);

  return deviceType;
};

export const useIsMobile = () => {
  const deviceType = useDeviceType();
  return deviceType === DEVICE_MOBILE;
};

export const useIsDesktop = () => {
  const deviceType = useDeviceType();
  return deviceType === DEVICE_DESKTOP;
};

export const useIsInWebView = () => {
  return jsBridge.canUseBridge();
};

export default useDeviceType;
